import { axios, URL_BASE, URL_USER } from "./_shared";

// =============================================
// ── Portal Clientes ──
// =============================================

// --- Client CRUD ---
export const createClient = (data) => axios.post(`${URL_BASE}client`, data);
export const getClients = () => axios.get(`${URL_BASE}client`);
export const updateClient = (data) => axios.put(`${URL_BASE}client`, data);
export const deleteClient = (clientId, email) =>
  axios.delete(`${URL_BASE}client`, { params: { clientId, email } });

// --- Login ---
export const postClienteLogin = ({ email, password }) => {
  return axios.post(
    URL_USER + "login",
    { username: email, password, company: "" },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

// --- Objetivos & Asistencia ---
export const getClienteObjetivos = () => axios.get(`${URL_BASE}client/objectives`);

export const getClienteAsistenciaGrouped = (params = {}) => axios.get(`${URL_BASE}client/attendance/grouped`, { params });

export const getClientePerfil = () => axios.get(`${URL_BASE}client/profile`);

export const exportClienteAsistencia = (params = {}) =>
  axios.get(`${URL_BASE}client/attendance/export`, { params, responseType: 'arraybuffer' });

// ========== Estadísticas y Cumplimiento ==========

export const getClienteStatsSummary = (params = {}) =>
  axios.get(`${URL_BASE}client/stats/summary`, { params });

export const getClienteStatsCustomerSummary = (params = {}) =>
  axios.get(`${URL_BASE}client/stats/customer-summary`, { params });

export const getClienteStatsAnnualSummary = (params = {}) =>
  axios.get(`${URL_BASE}client/stats/annual-summary`, { params });

export const exportClienteCustomerPDF = (params = {}) =>
  axios.get(`${URL_BASE}client/stats/customer-summary/export`, { params, responseType: 'blob' });

export const exportClienteObjectivePDF = (params = {}) =>
  axios.get(`${URL_BASE}client/stats/objective-summary/export`, { params, responseType: 'blob' });

export const getClientePlanillaCompliance = (params = {}) =>
  axios.get(`${URL_BASE}client/planilla/compliance`, { params });

export const getClientePlanillaComplianceSummary = (params = {}) =>
  axios.get(`${URL_BASE}client/planilla/compliance-summary`, { params });

// ========== Supervisión ==========

export const getClienteActasVisita = (params = {}) =>
  axios.get(`${URL_BASE}client/supervision/actas`, { params });

export const getClienteActaById = (actaId) =>
  axios.get(`${URL_BASE}client/supervision/actas/${actaId}`);

export const getClienteEventos = (params = {}) =>
  axios.get(`${URL_BASE}client/supervision/eventos`, { params });

export const getClienteEventoById = (eventoId) =>
  axios.get(`${URL_BASE}client/supervision/eventos/${eventoId}`);

export const getClienteSimulacros = (params = {}) =>
  axios.get(`${URL_BASE}client/supervision/simulacros`, { params });

export const getClienteSimulacroById = (simulacroId) =>
  axios.get(`${URL_BASE}client/supervision/simulacros/${simulacroId}`);

export const getClienteVisitas = (params = {}) =>
  axios.get(`${URL_BASE}client/supervision/visitas`, { params });

export const getClienteVisitaById = (visitaId) =>
  axios.get(`${URL_BASE}client/supervision/visitas/${visitaId}`);

export const getClienteDirectivas = (params = {}) =>
  axios.get(`${URL_BASE}client/supervision/directivas`, { params });

export const getClienteDirectivaById = (directivaId) =>
  axios.get(`${URL_BASE}client/supervision/directivas/${directivaId}`);

export const darVistoBuenoDirectivaCliente = (directivaId, observacion) =>
  axios.put(`${URL_BASE}client/supervision/directivas/${directivaId}/visto-bueno`, { observacion: observacion || null });

export const rechazarDirectivaCliente = (directivaId, observacion) =>
  axios.put(`${URL_BASE}client/supervision/directivas/${directivaId}/rechazar`, { observacion: observacion || null });

// ========== Accesos ==========

export const getClienteAccesos = (params = {}) =>
  axios.get(`${URL_BASE}client/accesos/movimientos`, { params });

export const getClienteAccesoById = (movimientoId) =>
  axios.get(`${URL_BASE}client/accesos/movimientos/${movimientoId}`);
